import PropTypes from "prop-types";
import FAQItem from "./FAQItem/index.jsx";
import style from "./styles";

const PremierDeliveryFAQs = ({ premierDeliveryFAQs }) => {
  const countryCode = window.asos && window.asos.webContext.getBrowseCountry();
  const countrySpecificLinks = premierDeliveryFAQs.faqs.map(
    (faq) => faq?.links?.[countryCode]
  );
  const hasLinks = premierDeliveryFAQs.faqs.some(
    (faq) => faq.link && faq.link.length > 0
  );
  const hasCountrySpecificLinks = countrySpecificLinks.some(
    (link) => link !== undefined
  );

  if (premierDeliveryFAQs && (hasLinks || hasCountrySpecificLinks)) {
    return (
      <div className={style.FAQsContainer}>
        <h2 className={style.FAQsTitle}>{premierDeliveryFAQs.title}</h2>
        <ul className={style.FAQsList}>
          {premierDeliveryFAQs.faqs.map((item, i) => {
            const countrySpecificLink = item.links && item.links[countryCode];

            if (countrySpecificLink || item.link)
              return (
                <FAQItem
                  key={i}
                  link={countrySpecificLink || item.link}
                  question={item.question}
                />
              );
          })}
        </ul>
      </div>
    );
  }

  return null;
};

PremierDeliveryFAQs.propTypes = {
  premierDeliveryFAQs: PropTypes.shape({
    title: PropTypes.string.isRequired,
    faqs: PropTypes.array.isRequired,
  }),
};

export default PremierDeliveryFAQs;
